<div class="loading-container">
  <ion-spinner></ion-spinner>
  @if (message) {
    <p class="loading-message">{{ message }}</p>
  }
</div>
